import styles from './Tag.module.scss'
import React from 'react'
import classNames from 'classnames'
import styled from 'styled-components'
import { ReactComponent as ZocksLogo } from '../../assets/ZocksLogo.svg'

export interface TagProps {
  selected?: boolean
  className?: string
  onClick?: () => void
  children?: React.ReactNode
}
export const Tag: React.FC<TagProps> = ({ selected = false, className, onClick, children }) => {
  const handleOnClick = () => {
    onClick && onClick()
  }

  return (
    <div role='button' onClick={handleOnClick} className={classNames(`${styles.tag} ${className ? className : ''}`, { [styles.tagSelected]: selected })}>
      {children}
    </div>
  )
}

export const TagElement = styled.div`
  display: flex;
  padding: 0.25rem 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  border-radius: 0.25rem;
  text-wrap: normal;
  background: var(--zocks-gray-200);
`

export const ZocksAIAssistantTag = () => {
  return (
    <div className='d-flex gap-2 p-2 zocks-bg-color-gray-100 align-items-center zocks-border-0.5 paragraph-small'>
      <div className={`d-flex align-items-center justify-content-center bg-black zocks-border-0.25 ${styles.aiAgentTagLogo}`}>
        <ZocksLogo width={12} height={12} />
      </div>
      <span className='bold'>ZOCKS</span>
      <span>AI Assistant</span>
    </div>
  )
}

export const ZocksAIAssistantTagVertical = () => {
  return (
    <div className='d-flex gap-2 align-items-center zocks-border-0.5 paragraph-small'>
      <div className={`d-flex align-items-center justify-content-center bg-black zocks-border-0.25 ${styles.aiAgentTagLogoVertical}`}>
        <ZocksLogo width={14} height={14} />
      </div>
      <div className='d-flex flex-column align-items-start'>
        <div className={`bold paragraph-extra-small`}>ZOCKS</div>
        <div className={`paragraph-extra-small`}>AI Assistant</div>
      </div>
    </div>
  )
}
